import gql from 'graphql-tag';

export default gql`
  mutation checkAndMergeCart($input: CheckAndMergeCartInput!) {
    checkAndMergeCart(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
